var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"chevron left\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.3232 15.6566C33.4132 14.7466 31.9432 14.7466 31.0332 15.6566L20.3232 26.3666C19.4132 27.2766 19.4132 28.7466 20.3232 29.6566L31.0332 40.3666C31.9432 41.2766 33.4132 41.2766 34.3232 40.3666C35.2332 39.4566 35.2332 37.9866 34.3232 37.0766L25.2699 28L34.3232 18.9466C35.2332 18.0366 35.2099 16.5433 34.3232 15.6566Z",
    fill: "#6B2C90"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronLeft);
export default __webpack_public_path__ + "static/media/icon-chevron-left.bfda893c4fe6173a48c804fbd804aac7.svg";
export { ForwardRef as ReactComponent };